"use strict";
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddChild = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var iconTypes_1 = require("../../iconTypes");
var svgIconContainer_1 = require("../../svgIconContainer");
exports.AddChild = React.forwardRef(function (props, ref) {
    var isLarge = props.size >= iconTypes_1.IconSize.LARGE;
    var pixelGridSize = isLarge ? iconTypes_1.IconSize.LARGE : iconTypes_1.IconSize.STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = { transformOrigin: "center" };
    return (React.createElement(svgIconContainer_1.SVGIconContainer, tslib_1.__assign({ iconName: "add-child", ref: ref }, props),
        React.createElement("path", { d: isLarge ? "M40 340V180H80V140H20C8.95432 140 0 148.954 0 160V360C0 371.0456 8.9543 380 20 380H380C391.046 380 400 371.0456 400 360V160C400 148.954 391.046 140 380 140H320V180H360V340H40zM220 120H260C271 120 280 111 280 100C280 89 271 80 260 80H220V40C220 29 211 20 200 20C189 20 180 29 180 40V80H140C129 80 120 89 120 100C120 111 129 120 140 120H180V160C180 171 189 180 200 180C211 180 220 171 220 160V120z" : "M40 280V160H60V120H16C7.16344 120 0 127.1634 0 136V304C0 312.83654 7.16344 320 16 320H304C312.836 320 320 312.83656 320 304V136C320 127.1634 312.836 120 304 120H260V160H280V280H40zM180 100H220C231 100 240 91 240 80C240 69 231 60 220 60H180V20C180 9 171 0 160 0C149 0 140 9 140 20V60H100C89 60 80 69 80 80C80 91 89 100 100 100H140V140C140 151 149 160 160 160C171 160 180 151 180 140V100z", fillRule: "evenodd", transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"), style: style })));
});
exports.AddChild.defaultProps = {
    size: iconTypes_1.IconSize.STANDARD,
};
exports.AddChild.displayName = "Blueprint5.Icon.AddChild";
exports.default = exports.AddChild;
//# sourceMappingURL=add-child.js.map